import { POST_PASSWORD, POST_PASSWORD_ERROR, POST_PASSWORD_SUCCESS, CLEAR_MESSAGE } from './constants'

export const postPassword = (payload) => ({ type: POST_PASSWORD, payload })
export const postPasswordSuccess = (message) => ({ type: POST_PASSWORD_SUCCESS, message })
export const postPasswordError = (error) => ({ type: POST_PASSWORD_ERROR, error })

export const clearMessage = () => ({ type: CLEAR_MESSAGE })
